<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <copy-prod />
      </div>
    </div>
  </section>
</template>

<script>
import CopyProdTemp from './Temp/CopyScheduleProdTemp.vue'

export default {
  name: 'Tables',
  components: {
    'copy-prod': CopyProdTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CopylimitedSchedule.vue?8bcc669e